module.exports = __webpack_public_path__ + "Server-Disabled.AzureServiceFabricCluster.2fedf0beb688a8ad2c62e9761f000876.hashedasset.svg";